<template>
	<div class="container__cardgrafico">
		<div class="container__cardgrafico__top">
			<div
				class="container__cardgrafico__top__info"
				style="width: 80%"
			>
				<label
					v-if="loading"
					class="loading"
					style="width: 30%; height: 30px"
				/>
				<label
					v-else
					class="container__cardgrafico__top__info__title"
					>{{ title }}</label
				>
				<label
					v-if="loading"
					class="loading"
					style="width: 20%; height: 15px; margin-top: 10px"
				/>
				<div
					v-else
					class="container__cardgrafico__top__info__subtitle"
					style="display: inline-flex; align-items: center; gap: 8px"
				>
					<slot name="subtitle-prefix" />
					<span>{{ setSubtitle }}</span>
				</div>
			</div>
			<div class="container__cardgrafico__top__buttons">
				<div
					v-if="loading"
					class="loading"
					style="width: 20%; height: 15px; margin-top: 10px"
				/>
				<slot
					v-else
					name="botoes"
				/>
			</div>
		</div>
		<div class="container__cardgrafico__body">
			<div
				v-if="loading"
				class="loading"
				style="width: 100%; height: 60vh; margin-top: 10px"
			/>
			<slot
				v-else
				name="grafico"
			/>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: String,
		subtitle: String,
		loading: { type: Boolean, default: false },
	},
	data() {
		return {
			counter: 0,
			counterSubtitle: '',
			counterInterval: {},
		}
	},
	computed: {
		setSubtitle() {
			if (this.subtitle === 'Buscando...') return this.subtitle
			return this.counterSubtitle || this.subtitle
		},
	},
	watch: {
		subtitle() {
			this.counter = 0
			this.counterSubtitle = ''
			if (this.subtitle === 'Atualizado agora') {
				clearInterval(this.counterInterval)

				this.counterInterval = setInterval(() => {
					this.counterSubtitle = `Atualizado há ${++this.counter} ${this.counter > 1 ? 'minutos' : 'minuto'}`
				}, 60000)
			}
		},
	},
}
</script>

<style scoped>
.container__cardgrafico {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: auto;
	padding: 1rem 2rem;
}

.container__cardgrafico__top {
	display: flex;
	flex-direction: column;
	width: 100%;
	justify-content: space-between;
	align-items: center;
}

.container__cardgrafico__top__info {
	display: flex;
	flex-direction: column;
	text-align: center;
}

.container__cardgrafico__top__info__title {
	color: rgb(var(--color-primary));
	font-weight: 700;
}

.container__cardgrafico__top__info__subtitle {
	color: var(--color-gray);
	font-size: 0.75rem;
}

.container__cardgrafico__top__buttons {
	display: flex;
	flex-direction: row;
	width: 100%;
}

.container__cardgrafico__body {
	margin: 0.5rem 0;
	width: 100%;
	height: 100%;
}

@media screen and (max-width: 1370px) {
	.container__cardgrafico {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: auto;
		padding: 0.1rem 0.2rem;
	}
}
@media screen and (min-width: 992px) {
	.container__cardgrafico__top {
		flex-direction: row;
	}
	.container__cardgrafico__top__info {
		text-align: unset;
	}

	.container__cardgrafico__top__buttons {
		width: unset;
	}
}

#dispersao__parcelas div {
	height: 100%;
}

.loading {
	animation: pulse-bg 1s infinite;
}

@keyframes pulse-bg {
	0% {
		background-color: #eee;
	}

	50% {
		background-color: #eaeaea;
	}

	100% {
		background-color: #eee;
	}
}
</style>
